const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class SsnInput {
  constructor(data, placeholder, validator) {
    this._data = data;
    this.element = cELM("div", "option-block");
    this.placeholder = placeholder || "";
    this.validator = validator || this.validator;
    this.elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    const inputEl = cELM("input", "text-input mr");
    inputEl.placeholder = this.placeholder;
    inputEl.type = "tel";
    inputEl.pattern = "\d*";
    inputEl.autofocus = true;
    inputEl.maxLength = 11;

    const buttonEl = cELM("div", "go-button", "Go");
    buttonEl.onclick = function(evt) {
      const op = inputEl.value;
      inputEl.classList.remove("invalid");
  
      if (_self.validator && !_self.validator(op)) {
        inputEl.classList.add("invalid");
        inputEl.focus();
        return;
      }

      Chat.default.send({
          text: op,
          id: _self._data.id
        },
        null, 
        _self.element
      );
    };

    const fnChange = function(evt) {
      if (evt.keyCode === 8) return false;

      const onlyNumber = evt.target.value.split("-").join("");
      const updatedNumber = (onlyNumber || '').trim();
      if (updatedNumber.length === 9) {
        inputEl.blur();
        buttonEl.click();
        return;
      }
      const area = onlyNumber.substring(0, 3);
      const group = onlyNumber.substring(3, 5);
      const serial = onlyNumber.substring(5, 9);

      let formatted = "";
      if (onlyNumber.length >= 5) {
        formatted = `${area}-${group}-${serial}`;
      } else if (onlyNumber.length >= 3) {
        formatted = `${area}-${group}`;
      } else if (onlyNumber.length > 0) {
        formatted = `${area}`;
      }

      evt.target.value = formatted;
    };

    inputEl.onkeypress = function(evt) {
      if(evt.keyCode === 8) {
        return true;
      }

      // Handle paste
      const regex = new RegExp(/^\d+$/);
      const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);

      if(!regex.test(key)) {
        evt.preventDefault();
        evt.stopPropagation();
        return false;
      }
    };
    inputEl.onkeyup = fnChange;

    this.element.addELM(Wrap4Arrow(inputEl, true));
    this.element.addELM(buttonEl);
    this.elements = { el: inputEl, btn: buttonEl };

    return this.element;
  }

  reset() {
    this.element.firstChild.value = "";
    this.element.firstChild.focus();
  }

  validator(n='') {
    n = n.split('-').join('');
    return n.match(/^\d{9}$/);
  }

  focus() {
    //this.elements.el.focus();
  }
}

module.exports = SsnInput;
